var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("e-sidebar", {
    attrs: {
      id: "sidebar-form-tier-promotion",
      title: _vm.isTierUpdate
        ? _vm.$t("Editar faixa da Promoção")
        : _vm.$t("Nova faixa da Promoção"),
      show: _vm.showSidebar,
      fetching: _vm.fetching,
      saving: _vm.saving,
      width: "500px",
    },
    on: { save: _vm.onSaveTier, hidden: _vm.onHideSidebar },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c(
              "FormulateForm",
              { ref: "tierSidebarForm", attrs: { name: "tierSidebarForm" } },
              [
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { attrs: { md: "6" } },
                      [
                        _c("FormulateInput", {
                          staticClass: "required",
                          attrs: {
                            id: "tier-minimum-amount",
                            type: "text-number",
                            currency: "R$",
                            precision: 2,
                            label: _vm.$t("Valor mínimo"),
                            validation: "required",
                          },
                          model: {
                            value: _vm.tierForm.minimumAmount,
                            callback: function ($$v) {
                              _vm.$set(_vm.tierForm, "minimumAmount", $$v)
                            },
                            expression: "tierForm.minimumAmount",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "b-row",
                  { staticClass: "mt-1" },
                  [
                    _c("b-col", [
                      _c("h6", [_vm._v(_vm._s(_vm.$t("Brindes")))]),
                    ]),
                  ],
                  1
                ),
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { attrs: { md: "12" } },
                      [
                        _c("e-search-sku", {
                          attrs: {
                            id: "tier-reward-sku",
                            required: false,
                            "value-is-object": "",
                            "only-active": "",
                          },
                          model: {
                            value: _vm.rewardForm.sku,
                            callback: function ($$v) {
                              _vm.$set(_vm.rewardForm, "sku", $$v)
                            },
                            expression: "rewardForm.sku",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "b-row",
                  { staticClass: "align-items-end" },
                  [
                    _c(
                      "b-col",
                      { attrs: { md: "6" } },
                      [
                        _c("FormulateInput", {
                          attrs: {
                            id: "tier-reward-quantity",
                            type: "text-number",
                            precision: 4,
                            label: _vm.$t("Quantidade"),
                          },
                          model: {
                            value: _vm.rewardForm.quantity,
                            callback: function ($$v) {
                              _vm.$set(_vm.rewardForm, "quantity", $$v)
                            },
                            expression: "rewardForm.quantity",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      {
                        staticClass: "d-flex justify-content-end mb-1",
                        attrs: { md: "6" },
                      },
                      [
                        _c("e-button", {
                          attrs: {
                            variant: "primary",
                            text: _vm.$t("Adicionar brinde"),
                          },
                          on: { click: _vm.addReward },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "b-row",
                  { staticClass: "mt-2" },
                  [
                    _c(
                      "b-col",
                      [
                        _c("b-table", {
                          ref: "rewardsTable",
                          staticClass: "bordered",
                          attrs: {
                            "show-empty": "",
                            responsive: "",
                            fields: _vm.rewardFields,
                            items: _vm.activeRewards,
                            "empty-text": _vm.$t("Nenhum brinde adicionado"),
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "cell(sku)",
                              fn: function (row) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        row.item.sku && row.item.sku.name
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                            {
                              key: "cell(action)",
                              fn: function (row) {
                                return [
                                  _c("e-grid-actions", {
                                    attrs: {
                                      "show-update": false,
                                      "show-delete": true,
                                    },
                                    on: {
                                      delete: function ($event) {
                                        return _vm.removeReward(row)
                                      },
                                    },
                                  }),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }